import AssetSvc from '@/services/AssetSvc';

// Dua pemanggil minta payload yang sama persis pas boot; yang barengan disatuin.
let sedangJalan = null;

export default async function getScopedAssets() {
  if (!sedangJalan) {
    sedangJalan = AssetSvc.getAssets({ params: { page: 1, max: 1000 } })
      .then((res) => res.data?.data || [])
      .finally(() => { sedangJalan = null; });
  }
  return sedangJalan;
}
